import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaPinterest = props => {
  if (props.id !== "_svgsocialmediapinterest") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21 4C12.163 4 5 11.164 5 20c0 8.837 7.163 16 16 16s16-7.163 16-16c0-8.836-7.163-16-16-16m1.33 20.145c-1.07 0-2.075-.577-2.418-1.233 0 0-.575 2.281-.696 2.721-.43 1.555-1.69 3.111-1.788 3.238-.067.089-.219.061-.233-.056-.028-.198-.35-2.16.03-3.762l1.271-5.393s-.315-.632-.315-1.565c0-1.467.85-2.563 1.908-2.563.9 0 1.335.676 1.335 1.487 0 .904-.576 2.257-.873 3.51-.248 1.052.526 1.908 1.561 1.908 1.875 0 3.139-2.409 3.139-5.262 0-2.17-1.46-3.794-4.119-3.794-3.001 0-4.873 2.24-4.873 4.742 0 .861.256 1.469.654 1.94.182.217.208.302.142.552-.048.182-.156.621-.202.794-.066.251-.27.342-.496.247-1.382-.564-2.026-2.077-2.026-3.781 0-2.811 2.37-6.182 7.073-6.182 3.779 0 6.265 2.734 6.265 5.668 0 3.884-2.158 6.784-5.34 6.784" fill="#202020" /></svg>;
};

SvgSocialmediaPinterest.displayName = "_svgsocialmediapinterest";
SvgSocialmediaPinterest.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaPinterest.defaultProps = {
  id: ''
};
export default SvgSocialmediaPinterest;